import React from "react";
import "./Impact.css";
import { motion } from "framer-motion";
import { FaPlug, FaHandshake, FaInfinity } from "react-icons/fa";
import { useLanguage } from "../../context/LanguageContext"; // Import

const Impact = () => {
  const { t } = useLanguage();

  // Configuration statique pour les chiffres (qui ne changent pas selon la langue)
  const numbers = ["+20%", "10%", "100%"];

  return (
    <section className="impact-section">
      <div className="impact-container">
        {/* BLOC 1 : LA PROMESSE TECHNIQUE */}
        <div className="tech-promise">
          <motion.div
            className="tech-content"
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            <div className="icon-box">
              <FaPlug />
            </div>
            <h2>
              {t.impact.techTitle} <br />
              <span className="text-gold">{t.impact.techTitleSpan}</span>
            </h2>
            <p>{t.impact.techDesc}</p>
          </motion.div>
        </div>

        {/* BLOC 2 : LES CHIFFRES CLÉS */}
        <div className="stats-grid">
          {t.impact.stats.map((stat, index) => (
            <motion.div
              key={index}
              className="stat-card"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.2, duration: 0.5 }}
            >
              <h3 className="stat-number text-gold">{numbers[index]}</h3>
              <h4>{stat.label}</h4>
              <p>{stat.desc}</p>
            </motion.div>
          ))}
        </div>

        {/* BLOC 3 : LEVIERS */}
        <div className="levers-grid">
          <motion.div
            className="lever-item"
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
          >
            <FaHandshake className="lever-icon" />
            <div>
              <h4>{t.impact.levers[0].title}</h4>
              <p>{t.impact.levers[0].desc}</p>
            </div>
          </motion.div>

          <motion.div
            className="lever-item"
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            transition={{ delay: 0.2 }}
          >
            <FaInfinity className="lever-icon" />
            <div>
              <h4>{t.impact.levers[1].title}</h4>
              <p>{t.impact.levers[1].desc}</p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default Impact;
